import React, { Component } from 'react'
import autoBind from 'react-autobind'
import Favicon from 'react-favicon'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Container } from 'semantic-ui-react'

import favicon from '../assets/images/ico.png'
import { tr } from '../helpers/languages'
import Messages from './messages'
import Routes from './routes'
import { send } from '../helpers/requests'

class Main extends Component {
    constructor (props) {
        super(props)
        global.Diagnoses = []
        let self = this
        const checkForToken = function () {
            if (self.props.userTokens.accessToken.token) {
                setTimeout(self.fetchDiagnoses, 1000)
            } else if (global.Diagnoses.length === 0) {
                setTimeout(checkForToken, 1000)
            }
        }
        autoBind(this)
        checkForToken()

        // this.fetchDiagnoses()

    }

    fetchDiagnoses () {
        console.log('Fetch diagnoses.')

        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: '/content/diagnoses'
        })
            .then((response) => {
                // eslint-disable-next-line no-console
                console.log('Fetched available diagnoses.')
                global.Diagnoses = [{ value: '', display: tr('UNSET_DIAGNOSIS') }, ...response.data]
            })
            .catch((error) => {
                // Failed to fetch diagnoses.
                // eslint-disable-next-line no-console
                console.error('Failed to fetch available diagnoses.', error)
            })
    }

    render () {
        return (
            <Container className='main'>
                <Favicon url={favicon}/>
                <Helmet>
                    <title>{tr('PAGE_TITLE')}</title>
                </Helmet>
                <Routes/>
                <Messages/>
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.settings.language,
        userTokens: state.users.userTokens
    }
}

const mapDispatchToProps = (_dispatch) => {
    return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Main))



// WEBPACK FOOTER //
// ./src/components/index.js